import { LitElement, html, Splide } from '@hh/global.js'

export class HHAnnouncementBar extends LitElement {
  static properties = {
    slider: { state: true },
  }

  connectedCallback() {
    super.connectedCallback()
    const slider = this.querySelector('.splide')
    if (slider) {
      this.initSlider(slider)
    }
  }

  initSlider(slider) {
    this.slider = new Splide(slider, {
      type: 'loop',
      arrows: true,
      pagination: false,
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      useScroll: true,
    })

    this.slider.mount()

    const arrowEls = this.slider.root.querySelectorAll('.splide__arrow')

    arrowEls.forEach((el) => {
      el.addEventListener('click', () => {
        const { Autoplay } = this.slider.Components
        Autoplay.pause()
      })
    })

    const pausePlayBtn = this.slider.root.querySelector('.splide__pause-play')
    pausePlayBtn.addEventListener('click', () => {
      this.toggleAutoplay(pausePlayBtn)
    })
  }

  toggleAutoplay(pausePlayBtn) {
    const { Autoplay } = this.slider.Components
    const isPaused = pausePlayBtn.getAttribute('aria-pressed') === 'true'

    if (isPaused) {
      Autoplay.play()
      pausePlayBtn.setAttribute('aria-pressed', 'false')
    } else {
      Autoplay.pause();
      pausePlayBtn.setAttribute('aria-pressed', 'true')
    }

    const pauseSVG = pausePlayBtn.querySelector('.pause-svg')
    const playSVG = pausePlayBtn.querySelector('.play-svg')
    pauseSVG.style.display = isPaused ? 'block' : 'none'
    playSVG.style.display = isPaused ? 'none' : 'block'
  }


  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-announcement-bar', HHAnnouncementBar)
